import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import utils from '../../../services/utils';

import { retefuenteLabelValueList, reteicaLabelValueList } from '../../../store/catalogs/accountabilityAccounts';
import { formTypes } from '../../../store/catalogs/forms';
import { taxesValueLabelList } from '../../../store/catalogs/taxes';
import Button from '../../Buttons/Button/Button';
import ShowArrowButton from '../../Buttons/ShowArrowButton/ShowArrowButton';
import LabelFieldFormik from '../../Fields/LabelField/LabelFieldFormik';
import Pagination from '../../Pagination/Pagination';
import Tags from '../../Tags/Tags';
import FormGrid from '../FormGrid/FormGrid';
import { ReactComponent as Trash } from '../../../assets/icons/Trash.svg';

import classes from './ItemsForm.module.scss';

const fieldsItem = {
  description: '',
  priceAmount: 0,
  invoiceQuantity: 0,
  lineExtensionAmount: 0,
  tax: 'none',
  payableAmount: 0,
  retefuenteAccountId: 0,
  reteicaAccountId: 0,
  taxableAmount: 0,
  taxAmount: 0,
  isShow: false
};

const ITEMS_PER_PAGE = 10;
//Pendiente volver mas general este componente
const ItemsForm = ({
  className,
  items,
  itemsForAdd,
  sendItem,
  values,
  keyFatherItems,
  isNotEditable,
  deleteItemsHandler,
  isCharge,
  setValuesItems
}) => {
  const contentClasses = [classes.content];

  className && contentClasses.push(className);

  const keyFather = keyFatherItems || 'items';

  const { setFieldValue } = useFormikContext();

  const [page, setPage] = useState(0);

  const pages = items.length / ITEMS_PER_PAGE;

  const setFields = () => {
    for (const key of Object.keys(fieldsItem)) {
      if (key === 'isShow') {
        items.length === 0 && setFieldValue(`${keyFather}.${items.length}.${key}`, true);
      } else {
        setFieldValue(`${keyFather}.${items.length}.${key}`, fieldsItem[key]);
      }
    }
  };

  const addItem = () => {
    setFields();

    const newItem = {
      idx: items.length,
      fields: [
        { key: `${keyFather}.${items.length}.description`, label: 'Nombre del item' },
        { key: `${keyFather}.${items.length}.priceAmount`, label: 'Valor', type: formTypes.money },
        { key: `${keyFather}.${items.length}.invoiceQuantity`, label: 'Cantidad', type: formTypes.number },
        { key: `${keyFather}.${items.length}.lineExtensionAmount`, label: 'Subtotal', type: formTypes.money, disabled: true },
        {
          key: `${keyFather}.${items.length}.tax`,
          label: 'Impuesto',
          type: formTypes.selectComplete,
          options: taxesValueLabelList.filter(({ value }) => value === '01').concat({ value: 'none', label: 'Ninguna', percent: 0 })
        },
        { key: `${keyFather}.${items.length}.payableAmount`, label: 'Total', type: formTypes.money, disabled: true },
        {
          key: `${keyFather}.${items.length}.retefuenteAccountId`,
          label: 'Cuenta contable retefuente',
          type: formTypes.select,
          options: retefuenteLabelValueList
        },
        {
          key: `${keyFather}.${items.length}.reteicaAccountId`,
          label: 'Cuenta contable reteica',
          type: formTypes.select,
          options: reteicaLabelValueList
        }
      ]
    };
    sendItem(itemsForAdd ? itemsForAdd : newItem);
  };

  const showDetailHandler = idx => {
    setFieldValue(`${keyFather}.${idx}.isShow`, !values.items[idx].isShow);
  };

  const calculateSubtotalAndTotal = (idx, subtotal, percent) => {
    setFieldValue(`${keyFather}.${idx}.lineExtensionAmount`, subtotal);
    setFieldValue(`${keyFather}.${idx}.payableAmount`, subtotal + percent * subtotal);
    setFieldValue(`${keyFather}.${idx}.taxAmount`, percent * subtotal);
  };

  const setValues = (idx, key, value) => {
    const percent = values.items[idx].tax === '01' ? 0.19 : 0;
    if (key.includes('priceAmount')) {
      const subtotal = (value ? value : 0) * (values.items[idx].invoiceQuantity ? values.items[idx].invoiceQuantity : 0);
      calculateSubtotalAndTotal(idx, subtotal, percent);
    } else if (key.includes('invoiceQuantity')) {
      const subtotal = (value ? value : 0) * (values.items[idx].priceAmount ? values.items[idx].priceAmount : 0);
      calculateSubtotalAndTotal(idx, subtotal, percent);
    } else if (key.includes('tax')) {
      setFieldValue(`${keyFather}.${idx}.taxComplete`, value);
      const percent = value.value === '01' ? value.percent / 100 : 0;
      const taxAmount = percent * values.items[idx].lineExtensionAmount;
      setFieldValue(`${keyFather}.${idx}.payableAmount`, values.items[idx].lineExtensionAmount + taxAmount);
      setFieldValue(`${keyFather}.${idx}.taxAmount`, taxAmount);
    }
    key.includes('tax') ? setFieldValue(key, value.value) : setFieldValue(key, value);
  };

  const deleteItem = idx => {
    const newItems = values.items.filter((item, index) => index !== idx);
    setFieldValue(`${keyFather}`, newItems);
    deleteItemsHandler(idx);
  };
  return (
    <div className={contentClasses.join(' ')}>
      {items.slice(page * ITEMS_PER_PAGE, ITEMS_PER_PAGE * (page + 1)).map(item => {
        const isFillOut = values.items[item.idx].payableAmount !== 0 && !!values.items[item.idx].description;
        return (
          <div key={item.idx} className={classes.card}>
            <div className={classes.space}>
              <span className='semibold-18'>Item {item.idx + 1}</span>
              <div className={classes['space-tag']}>
                {!isNotEditable && (
                  <Button onClick={() => deleteItem(item.idx)} Icon={Trash} custom='quaternary' color='gray'>
                    Eliminar
                  </Button>
                )}
                <Tags text={isFillOut ? 'Diligenciada' : 'No diligenciada'} type={isFillOut ? 'green' : 'gray'} />
                <ShowArrowButton showState={values.items[item.idx].isShow} onClick={() => showDetailHandler(item.idx)} />
              </div>
            </div>
            {values.items[item.idx].isShow && (
              <FormGrid
                className={classes.form}
                onChange={
                  setValuesItems
                    ? (key, value) => setValuesItems(item.idx, key, value, setFieldValue)
                    : (key, value) => setValues(item.idx, key, value)
                }
                fields={item.fields}
                Render={LabelFieldFormik}
              />
            )}
          </div>
        );
      })}

      <Pagination
        className={classes.pagination}
        pages={pages}
        current={page}
        showNext={page < pages - 1}
        onPrevious={() => setPage(page => page - 1)}
        onNext={() => setPage(page => page + 1)}
        onPage={page => setPage(page)}
        limit={ITEMS_PER_PAGE}
        //onLimit={limitChangeHandler}
      />

      {!isNotEditable && <Button onClick={addItem}>Agregar item</Button>}

      <div className={classes.totals}>
        {!isCharge ? (
          <>
            <div className={classes.total}>
              <span className='semibold-14'>Subtotal sin retenciones</span>
              <span className='semibold-14'>
                {values.items
                  ? utils.moneyFormat(values.items.reduce((prev, { lineExtensionAmount }) => prev + lineExtensionAmount, 0))
                  : 0}
              </span>
            </div>
            <div className={classes.total}>
              <span className='medium-14'>Impuestos sobre total (%)</span>
              <span className='medium-14'>
                {values.items ? utils.moneyFormat(values.items.reduce((prev, { taxAmount }) => prev + taxAmount, 0)) : 0}
              </span>
            </div>
          </>
        ) : (
          <div></div>
        )}
        <div className={classes.total}>
          <span className='bold-20'>MONTO TOTAL</span>
          <span className='bold-20'>
            {values.items ? utils.moneyFormat(values.items.reduce((prev, { payableAmount }) => prev + payableAmount, 0)) : 0}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ItemsForm;
